export class CommonResult<DataType> {
  public data: DataType;
}
